import { render, staticRenderFns } from "./ChangeManualQCStatusModal.vue?vue&type=template&id=1a4e4680&"
import script from "./ChangeManualQCStatusModal.vue?vue&type=script&lang=js&"
export * from "./ChangeManualQCStatusModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports